import { FileUploadActionTypes, FileUploadAction, UploadedFileInfo } from './actions';

export interface FileUploadsState {
  files: UploadedFileInfo[];
  loading: boolean;
  error: string | null;
}

const initialState: FileUploadsState = {
  files: [],
  loading: false,
  error: null,
};

export const fileUploadsReducer = (state = initialState, action: FileUploadAction): FileUploadsState => {
  switch (action.type) {

    case FileUploadActionTypes.UPLOAD_FILE_REQUEST: {
      const { file, tempId, prescID, licensesID } = action.payload;
      return {
        ...state,
        loading: true,
        files: [
          ...state.files,
          {
            id: 0,
            documentId: '',
            name: file.name,
            url: '',
            size: file.size,
            mime: file.type,
            prescID: prescID,
            licensesID: licensesID,
            progress: 0,
            isUploading: true,
            tempId: tempId,
          },
        ],
      };
    }

    case FileUploadActionTypes.UPLOAD_FILE_SUCCESS: {
      const uploadedFile = action.payload;
      return {
        ...state,
        loading: false,
        files: state.files.map((file) => (file.tempId === uploadedFile.tempId ? uploadedFile : file)),
        error: null,
      };
    }

    case FileUploadActionTypes.UPLOAD_FILE_FAILURE: {
      const { error, tempId } = action.payload;
      return {
        ...state,
        loading: false,
        files: state.files.filter((file) => file.tempId !== tempId),
        error,
      };
    }

    case FileUploadActionTypes.UPLOAD_FILE_PROGRESS: {
      const { progress, tempId } = action.payload;
      return {
        ...state,
        files: state.files.map((file) => (file.tempId === tempId ? { ...file, progress } : file)),
      };
    }

    case FileUploadActionTypes.FETCH_FILES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FileUploadActionTypes.FETCH_FILES_SUCCESS:
      return {
        ...state,
        loading: false,
        files: action.payload,
        error: null,
      };

    case FileUploadActionTypes.FETCH_FILES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case FileUploadActionTypes.DELETE_FILE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FileUploadActionTypes.DELETE_FILE_SUCCESS: {
      const { documentId, uploadId } = action.payload;
      return {
        ...state,
        loading: false,
        files: state.files.filter((file) => {
          const matchesDocId = documentId && file.documentId === documentId;
          const matchesUploadId = uploadId && file.uploadId === uploadId;
          return !matchesDocId && !matchesUploadId;
        }),
        error: null,
      };
    }

    case FileUploadActionTypes.DELETE_FILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case FileUploadActionTypes.DOWNLOAD_FILE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FileUploadActionTypes.DOWNLOAD_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case FileUploadActionTypes.DOWNLOAD_FILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
};
